import React from 'react';
import { Outlet } from "react-router-dom";
import Header from '../components/Header';
import RotateDevice from './RotateDevice';
import { useMediaQuery } from 'react-responsive';
// import Footer from '../components/Footer';
import styles from '../styles/layout.module.css';

const Layout = () => {
  // Detect if the device is in landscape mode and is a mobile device
  const isLandscapeMobile = useMediaQuery({
    query: '(max-device-width: 768px) and (orientation: landscape)',
  });

  return (
    <>
        {!isLandscapeMobile && <Header />}
        <div className={styles.app}>
            {!isLandscapeMobile ? <Outlet /> : <RotateDevice />}
        </div>
    </>
  )
};

export default Layout;